export const PRODUCT_LIST_READY = "product-list:ready";
export const PRODUCT_LIST_EMPTY = "product-list:empty";
export const PRODUCT_LIST_CARD_IN_VIEW = "product-list:card-in-view";
export const PRODUCT_LIST_QUICKVIEW_OPENED = "product-list:quick-view:opened";
export const PRODUCT_LIST_QUICKVIEW_UPDATED = "product-list:quick-view:updated";
export const PRODUCT_LIST_QUICKVIEW_ADD_TO_BASKET =
  "product-list:quick-view:add-to-basket";
